import React, { useState,useEffect } from "react";
import styles from "./sidebar.module.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link,withRouter } from "react-router-dom";

const Sidebar = (props) => {
  const [select, setSelect] = useState(0);
  const params=props.location?.pathname;
  useEffect(()=>{
    if(params==='/faculty-contribution/'){
      setSelect(0)
    }
    else if(params==='/faculty-contribution/faculty_workload'){
      setSelect(1)
    }
    else if(params==='/faculty-contribution/research_publication'){
      setSelect(2)
    }
    else if(params==='/faculty-contribution/consultancy_project'){
      setSelect(3)
    }
    else if(params==='/faculty-contribution/sponsored_project'){
      setSelect(4)
    }
    else if(params==='/faculty-contribution/awards_honors'){
      setSelect(5)
    }
    else if(params==='/faculty-contribution/patent_innovation'){
      setSelect(6)
    }
    else if(params==='/faculty-contribution/book_published'){
      setSelect(7)
    }
    else if(params==='/faculty-contribution/book_chapter'){
      setSelect(8)
    }
    else if(params==='/faculty-contribution/scholarship'){
      setSelect(9)
    }
    else if(params==='/faculty-contribution/workshop_organized'){
      setSelect(10)
    }
    else if(params==='/faculty-contribution/workshop_attended'){
      setSelect(11)
    }
    else if(params==='/faculty-contribution/professional_bodies'){
      setSelect(12)
    }
    else if(params==='/faculty-contribution/research_projects'){
      setSelect(13)
    }
  },[params])
  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={select}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{ style: { background: "transparent" } }}
      >
        <Tab
          component={Link}
          to="/faculty-contribution/"
          label="Faculty Profile"
          style={{ minWidth: "100%" }}
          className={select == 0 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(0)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/faculty_workload"
          label="Faculty Workload"
          style={{ minWidth: "100%" }}
          className={select == 1 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(1)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/research_publication"
          label="Research Publication"
          style={{ minWidth: "100%" }}
          className={select == 2 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(2)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/consultancy_project"
          label="Consultancy / Testing Projects"
          style={{ minWidth: "100%" }}
          className={select == 3 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(3)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/sponsored_project"
          label="Sponsored Projects"
          style={{ minWidth: "100%" }}
          className={select == 4 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(4)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/awards_honors"
          label={`Awards & Honors`}
          style={{ minWidth: "100%" }}
          className={select == 5 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(5)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/patent_innovation"
          label={`Patent & Innovation`}
          style={{ minWidth: "100%" }}
          className={select == 6 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(6)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/book_published"
          label="Book Published"
          style={{ minWidth: "100%" }}
          className={select == 7 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(7)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/book_chapter"
          label="Book Chapter"
          style={{ minWidth: "100%" }}
          className={select == 8 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(8)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/scholarship"
          label="Fellowship / Scholarship"
          style={{ minWidth: "100%" }}
          className={select == 9 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(9)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/workshop_organized"
          label="Conference / Seminar / Training / Development / Workshop Organized"
          style={{ minWidth: "100%" }}
          className={select == 10 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(10)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/workshop_attended"
          label="Conference / Seminar / Training / Development / Workshop Attended"
          style={{ minWidth: "100%" }}
          className={select == 11 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(11)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/professional_bodies"
          label="Professional Bodies"
          style={{ minWidth: "100%" }}
          className={select == 12 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(12)}
        />
        <Tab
          component={Link}
          to="/faculty-contribution/research_projects"
          label="Research Projects"
          style={{ minWidth: "100%" }}
          className={select == 13 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(13)}
        />
      </Tabs>
    </>
  );
};

export default withRouter(Sidebar);
